module.exports = __webpack_public_path__ + "img/W-S04.4dec9df7.jpg";